import { render, staticRenderFns } from "./MakerDai.vue?vue&type=template&id=cc758f54&scoped=true&"
import script from "./MakerDai.vue?vue&type=script&lang=js&"
export * from "./MakerDai.vue?vue&type=script&lang=js&"
import style0 from "./MakerDai.vue?vue&type=style&index=0&id=cc758f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc758f54",
  null
  
)

export default component.exports